<!-- 复制草稿到其他公众号 - 操作记录 -->
<template>
<div>
	<div style="background-color:#fff;padding: 20px;margin-bottom: 15px;">
		<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
			<div class="screen-box">
				<div class="screen-label">时间范围</div>
				<dateRangePicker :date_width="260" :before_number="date_number"
				@onGetDate="onGetDate"></dateRangePicker>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">草稿来源渠道</div>
				<a-select
					show-search
					allowClear
					style="width: 180px"
					placeholder="请选择草稿来源渠道"
					@change="handleChangeB"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
				  >
					<a-select-option v-for="(item,index) in bookList" :key="index" :value="item.key">
					  {{item.label}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">草稿来源公众号</div>
				<a-select
					show-search
					allowClear
					notFoundContent="← 请先选择: 来源渠道" 
					style="width: 200px"
					placeholder="请选择草稿来源公众号"
					@change="handleChangeA"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
				  >
					<a-select-option v-for="(value,key) in gzhSelect" :key="key" :value="key">
					  {{value}}
					</a-select-option>
				</a-select>
			</div>
			
			<div class="screen-box">
				<div class="screen-label">创建状态</div>
				<a-select
					show-search
					allowClear
					style="width: 160px"
					placeholder="请选择创建状态"
					@change="handleChangeD"
					:filter-option="filterOption"
					:getPopupContainer="getsPopupContainer"
				  >
					<a-select-option :value="0">待进行</a-select-option>
					<a-select-option :value="1">成功</a-select-option>
					<a-select-option :value="2">失败</a-select-option>
					<a-select-option :value="3">进行中</a-select-option>
				</a-select>
			</div>
			
			<a-button class="screen-box" @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search">搜索</a-button>
		</div>
	</div>
	
	<div style="background-color:#fff;padding:20px;">
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_tem.type != 'status' && z_tem.type != 'remark'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<!-- 状态 -->
				<div v-else-if="z_tem.type == 'status'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type] | statusFilters}}
				</div>
				<!-- 备注 -->
				<div v-else-if="z_tem.type == 'remark'" class="table-td-cell" :style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-for="(item_z,index_z) in item.remark" :key="index_z">
						{{item_z}}
					</div>
				</div>
				
			</template>
		</div>
		
		
		<!-- 表格内容为空时显示 -->
		<div v-show="tableShowData.length == 0" style="text-align: center;text-align:center;padding: 80px 0 50px;"
		:style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
		<!-- 分页 -->
		<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
		:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
		@pagination-Change="paginationChange"></pagingCompont>
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import { gzhDraftCopyLog, materialChannelSelect, wxMaterialSelect } from '@/request/api'
export default {
	name: 'copyDraftsSync_',
	components: {
		
	},
	data() {
		return {
			startTime: '2023-05-26',
			endTime: '2023-05-26',
			date_number: 0,
			
			bookList: [], // 渠道下拉
			gzhSelect: [], // 公众号下拉
			
			r_channel_id: undefined, // 草稿箱对应的渠道id
			r_gzh_id: undefined, // 草稿箱公众号id
			r_status: undefined, // 状态 0=待进行，1=成功，2=失败，3=进行中
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"本地草稿ID", width:100, type:"draft_id", },
				
				{title:"来源渠道", width:100, type:"channel_name", },
				{title:"来源公众号", width:100, type:"gzh_name", },
				{title:"目标渠道", width:100, type:"to_channel_name", },
				{title:"目标公众号", width:100, type:"to_gzh_name", },
				{title:"同步时间", width:120, type:"created_at", },
				{title:"同步状态", width:100, type:"status", },
				{title:"同步状态备注", width:200, type:"remark", },
				// {title:"草稿箱对应的公众号ID", width:100, type:"draft_gzh_id", },
				// {title:"需要同步到的公众号ID", width:100, type:"gzh_id", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			table_null_width: 1000,
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 20, // 每页多少条
			table_total: 0, // 表格内容总数
		}
	},
	mounted() {
		let that = this
		
		this.endTime = this.$getThisDay()
		this.startTime = this.$getThisDay()
		
		// 获取表格信息
		let body_width = document.body.clientWidth - 60 - 50 - 190 // 筛选条件大盒子的宽度
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		let table_width = 0
		// 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
		if(nn < body_width && body_width - nn > 50){ // 当表格内容不足以沾满一屏时，要适配成一屏
			// console.log("适配")
			that.rableTitle.forEach(res=>{ // 针对表格每一项的宽度进行适配
				res.width = Math.round((res.width/nn)*(body_width)) // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
			})
			table_width = body_width
		}
		else { // 表格宽度大于等于屏幕可视宽度
			// console.log("不适配")
			table_width = nn
		}
		that.table_scroll_width = table_width
		that.table_null_width = table_width
		
		materialChannelSelect().then(res=>{
			console.log("下拉",res);
			that.selectData = res.data.data
			let c_data = res.data.data.channel
			let show_data = []
			for (let key in c_data) {
				let ooo = {
					key,
					label: c_data[key],
					status: false,
				}
				show_data.push(ooo)
			}
			// show_data[0].status = true
			that.bookList = show_data
			console.log("show_data",show_data);
		})
		
		that.searchButton()
	},
	methods:{
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 日期选择
		onGetDate(date_start, date_end) {
			this.startTime = date_start
			this.endTime = date_end
		},
		// 公众号
		handleChangeA(value) {
			console.log(value)
			this.r_gzh_id = value 
		    
		},
		// 书城
		handleChangeB(e){
			this.r_channel_id = e
			this.search_button_loading = true
			this.getGzhSelect(e)
		},
		// 状态
		handleChangeD(e){
			this.r_status = e
		},
		// 根据渠道获取公众号
		getGzhSelect(e){
			let that = this
			wxMaterialSelect({
				channel_id: e
			}).then(res=>{
				that.search_button_loading = false
				
				if(res.data.code == 401){ // 未登录
					localStorage.removeItem("access_token");
					that.$router.replace({name: 'login',params: {type:'not_log'}})
					return
				}
				
				console.log("根据渠道获取公众号",res);
				that.gzhSelect = res.data.data.list
			})
		},
		
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				start_date: that.startTime + ' 00:00:00',
				end_date: that.endTime + ' 23:59:59',
				page: that.r_page,
				limit: that.r_limit,
				
				status: that.r_status, // 状态
				channel_id: that.r_channel_id, // 书城
				gzh_id: that.r_gzh_id, // 公众号
			}
			
			gzhDraftCopyLog(r_data).then(res=>{
				console.log("复制草稿列表",res);
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					if(type == 'button'){
						that.$message.success('搜索成功');
					}
					that.table_total = res.data.data.total
					let data = res.data.data.data
					// data.forEach(res=>{
					// 	res.checked = false
					// })
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
		
	},
	filters: {
		statusFilters(value){
			let vvv = ""
			if(value == 0){
				vvv = "待进行"
			}
			else if(value == 1){
				vvv = "成功"
			}
			else if(value == 2){
				vvv = "失败"
			}
			else if(value == 3){
				vvv = "进行中"
			}
			return vvv
		}
	}
}
</script>

<style>
</style>